import React from "react";
import { graphql } from "gatsby";
import Layout from "./../components/Layout";
import VenueHeader from "./../components/VenueHeader";
import { BigButton, SmallButton } from "./../components/Buttons";
import ArticleBody from "./../components/ArticleBody";
import { H3Strong } from "./../components/Typography";
import Download from "./../components/icons/Download";
import RegisterYourInterestForm from "./../components/RegisterYourInterestForm";
import {
  ArticleBodyWrapper,
  VenueBottomDiv,
  SubtitleWrapper,
} from "./../components/VenueStyles/elements";

const VenuePageTemplate = ({ data, pageContext }) => {
  // console.log(data, pageContext);
  const {
    title,
    richContent,
    subtitle,
    venuePdfForDownload,
    callToAction,
  } = data.craftEntryInterface;
  const [formShown, setFormShown] = React.useState(false);

  return (
    <Layout
      backgroundColor={"var(--green)"}
      footerColor={"var(--green)"}
      headerColor={"var(--black)"}
      headerBlack
      title={title}
      SEODescription={subtitle}
    >
      <VenueHeader title={title} selected={title} />
      <ArticleBodyWrapper>
        <SubtitleWrapper>
          <BigButton
            color={"var(--purple)"}
            onClick={() => {
              setFormShown(true);
            }}
          >
            {callToAction || "Get in touch"}
          </BigButton>
          <H3Strong>{subtitle}</H3Strong>
        </SubtitleWrapper>
        <ArticleBody
          mainColumn={richContent}
          color={"var(--purple)"}
          textColor={"var(--black)"}
          leftColumn={
            venuePdfForDownload.length ? (
              <a
                href={
                  venuePdfForDownload.length ? venuePdfForDownload[0].url : null
                }
                download
              >
                <SmallButton>
                  <Download color={"var(--color)"} />
                  Download PDF pack
                </SmallButton>
              </a>
            ) : null
          }
        />
      </ArticleBodyWrapper>
      <VenueBottomDiv>
        <BigButton
          color={"var(--purple)"}
          onClick={() => {
            setFormShown(true);
          }}
        >
          {callToAction || "Get in touch"}
        </BigButton>
      </VenueBottomDiv>
      {formShown ? (
        <RegisterYourInterestForm
          venueName={title}
          closeForm={() => {
            setFormShown(false);
          }}
        />
      ) : null}
    </Layout>
  );
};

export default VenuePageTemplate;

export const pageQuery = graphql`
  query($id: String!) {
    craftEntryInterface(id: { eq: $id }) {
      ... on Craft_venues_venues_Entry {
        id
        title
        subtitle
        callToAction
        venuePdfForDownload {
          url
        }
        richContent {
          ... on Craft_richContent_matterportEmbed_BlockType {
            typeHandle
            matterportUrl
          }
          ... on Craft_richContent_podiantPlayer_BlockType {
            podiantUrl
            typeHandle
          }
          ... on Craft_richContent_anghamiPlayer_BlockType {
            anghamiUrl
            typeHandle
          }
          ... on Craft_richContent_soundcloudPlayer_BlockType {
            soundcloudUrl
            typeHandle
          }
          ... on Craft_richContent_spotifyPlayer_BlockType {
            spotifyUrl
            typeHandle
          }
          ... on Craft_richContent_image_BlockType {
            id
            typeHandle
            imageWithCaptionImage {
              ... on Craft_communityAssets_Asset {
                slide: localFile {
                  publicURL
                  childImageSharp {
                    fixed(width: 715, fit: COVER) {
                      src
                      ...GatsbyImageSharpFixed
                    }
                  }
                }
              }
              ... on Craft_eventsAssets_Asset {
                slide: localFile {
                  publicURL
                  childImageSharp {
                    fixed(width: 715, fit: COVER) {
                      src
                      ...GatsbyImageSharpFixed
                    }
                  }
                }
              }
              ... on Craft_editorialAssets_Asset {
                slide: localFile {
                  publicURL
                  childImageSharp {
                    fixed(width: 715, fit: COVER) {
                      src
                      ...GatsbyImageSharpFixed
                    }
                  }
                }
              }
            }
            imageWithCaptionCaption
          }
          ... on Craft_richContent_slideShow_BlockType {
            id
            typeHandle
            images {
              ... on Craft_communityAssets_Asset {
                slide: localFile {
                  publicURL
                  childImageSharp {
                    fixed(height: 460, fit: COVER) {
                      src
                      ...GatsbyImageSharpFixed
                    }
                  }
                }
              }
              ... on Craft_eventsAssets_Asset {
                slide: localFile {
                  publicURL
                  childImageSharp {
                    fixed(height: 460, fit: COVER) {
                      src
                      ...GatsbyImageSharpFixed
                    }
                  }
                }
              }
               ... on Craft_AssetInterface {
                ... on Craft_editorialVideo_Asset{
 									slide: localFile {
                  publicURL
                  childImageSharp {
                    fixed(height: 460, fit: COVER) {
                      src
                      ...GatsbyImageSharpFixed
                    }
                  }
                }
                }
              }
              ... on Craft_editorialAssets_Asset {
                slide: localFile {
                  publicURL
                  childImageSharp {
                    fixed(height: 460, fit: COVER) {
                      src
                      ...GatsbyImageSharpFixed
                    }
                  }
                }
              }
            }
            carouselCaption
          }
          ... on Craft_richContent_richText_BlockType {
            id
            typeHandle
            richText
          }
          ... on Craft_richContent_imageSlider_BlockType {
            typeHandle
            imageSliderImages {
              ... on Craft_communityAssets_Asset {
                slide: localFile {
                  publicURL
                  childImageSharp {
                    fixed(height: 460, fit: COVER) {
                      src
                      ...GatsbyImageSharpFixed
                    }
                  }
                }
              }
              ... on Craft_eventsAssets_Asset {
                slide: localFile {
                  publicURL
                  childImageSharp {
                    fixed(height: 460, fit: COVER) {
                      src
                      ...GatsbyImageSharpFixed
                    }
                  }
                }
              }
              ... on Craft_editorialAssets_Asset {
                slide: localFile {
                  publicURL
                  childImageSharp {
                    fixed(height: 460, fit: COVER) {
                      src
                      ...GatsbyImageSharpFixed
                    }
                  }
                }
              }
            }
            imageSliderCaptions {
              captionLine4
              captionLine3
              captionLine2
              captionLine1
            }
          }
          ... on Craft_richContent_videoWithCaption_BlockType {
            typeHandle
            videoWithCaptionCaption
            videoWithCaptionVideoOnTheLeft
            videoWithCaptionUseCredit
            videoWithCaptionUrl
            videoWithCaptionVideo {
              url
            }
          }
          ... on Craft_richContent_photoWithQuote_BlockType {
            typeHandle
            photoWithQuoteImage {
              ... on Craft_communityAssets_Asset {
                slide: localFile {
                  publicURL
                  childImageSharp {
                    fixed(height: 460, fit: COVER) {
                      src
                      ...GatsbyImageSharpFixed
                    }
                  }
                }
              }
              ... on Craft_eventsAssets_Asset {
                slide: localFile {
                  publicURL
                  childImageSharp {
                    fixed(height: 460, fit: COVER) {
                      src
                      ...GatsbyImageSharpFixed
                    }
                  }
                }
              }
              ... on Craft_editorialAssets_Asset {
                slide: localFile {
                  publicURL
                  childImageSharp {
                    fixed(height: 460, fit: COVER) {
                      src
                      ...GatsbyImageSharpFixed
                    }
                  }
                }
              }
            }
            photoWithQuoteImageOnTheLeft
            photoWithQuoteImageQuote
            photoWithQuoteImageQuoteAttribution
          }
        }
      }
    }
  }
`;
